import { render, staticRenderFns } from "./vessel-task-view.vue?vue&type=template&id=5104fa38&scoped=true"
import script from "./vessel-task-view.vue?vue&type=script&lang=js"
export * from "./vessel-task-view.vue?vue&type=script&lang=js"
import style0 from "./vessel-task-view.vue?vue&type=style&index=0&id=5104fa38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104fa38",
  null
  
)

export default component.exports